import { render, staticRenderFns } from "./buttonBar.component.vue?vue&type=template&id=554456bc"
import script from "./buttonBar.component.ts?vue&type=script&lang=ts&external"
export * from "./buttonBar.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554456bc')) {
      api.createRecord('554456bc', component.options)
    } else {
      api.reload('554456bc', component.options)
    }
    module.hot.accept("./buttonBar.component.vue?vue&type=template&id=554456bc", function () {
      api.rerender('554456bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site/buttonBar.component.vue"
export default component.exports